import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('Toast', [
  'root',
  'shell',
  'content',
  'contentFullPadding',
  'prefix',
  'main',
  'text',
  'liveRegion',
  'title',
  'description',
  'suffix',
  'dismiss',
]);

export const toastRootCss = css`
  display: flex;
  align-items: flex-start;
  gap: var(--cds-spacing-50);
  padding: var(--cds-spacing-50);
  border-radius: var(--cds-border-radius-100);
  width: 100%;
  box-sizing: border-box;
  color: var(--cds-color-neutral-primary);
  background: var(--cds-color-neutral-background-primary);
  border: none;
  box-shadow: var(--cds-elevation-level3);

  .${classes.shell} {
    display: flex;
    align-items: flex-start;
    gap: var(--cds-spacing-50);
    flex: 1;
    min-width: 0;
    border-radius: inherit;

    &:focus-visible {
      outline: 2px solid var(--cds-color-interactive-stroke-primary-focus);
      outline-offset: 2px;
    }
  }

  .${classes.content} {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: flex-start;
    gap: var(--cds-spacing-100);
    padding: var(--cds-spacing-150);
    padding-inline-end: 0;

    /* Avoid overflow: clip — it can interfere with screen readers picking up the
       inner role="status"/alert live region updates in some browser+AT pairs. */
    overflow: visible;
    align-self: stretch;
  }

  .${classes.contentFullPadding} {
    padding-inline-end: var(--cds-spacing-150);
  }

  .${classes.prefix} {
    flex-shrink: 0;
    width: fit-content;
    max-width: max-content;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    line-height: 0;
  }

  .${classes.prefix} > * {
    display: block;
    flex-shrink: 0;
  }

  .${classes.main} {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: var(--cds-spacing-50) var(--cds-spacing-100);
  }

  .${classes.text} {
    flex: 999 1 12.5rem;
    min-width: 12.5rem;
  }

  .${classes.liveRegion} {
    min-width: 0;
  }

  .${classes.title} {
    margin: 0 0 var(--cds-spacing-25);
    font: var(--cds-typography-subtitle-medium);
  }

  .${classes.description} {
    margin: 0;
    font: var(--cds-typography-body-secondary);
    color: var(--cds-color-neutral-primary-weak);
  }

  .${classes.suffix} {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    align-self: stretch;
    min-height: var(--cds-spacing-400);
    flex: 1 0 auto;
  }

  .${classes.dismiss} {
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
  }
`;
